import { initMemberPledgeAddModal } from './member-pledge-add-modal';
import { AJAX_TIMEOUT_MESSAGE } from '../helpers.js';
import { getMemberOverlayElement, showOverlay, hideOverlay } from '../shared/overlay.js';
import {
    initPledgeEditOngoingModal,
    readPledgeEditOngoingModalConfig,
    createDefaultPledgeEditOngoingModalDeps,
    openCancelRecurringConfirm,
} from '../manager/pledges/pledge-edit-ongoing-modal';
import createPledgesRowActionHandlers from '../manager/pledges/pledges-row-actions';
import { initializeRowExpander } from '../manager/row-expander/index.js';
import { populateOngoingEditModal } from '../shared/ongoing-pledge-edit-populate.js';
import { initPayPledgeMap } from '../pledge-pay/pay-pledge-map';
import { DEFAULT_MEMBER_ID } from '../shared/default-member-id';
import { initMemberPledgesGrid } from './member-pledges-grid.js';
import { getMemberNavAction, runMemberNavAction } from './member-nav-registry.js';
import { showAlertMsg } from './member-show-alert-msg.js';
import { openIndexPage } from './member-open-index-page.js';
import { initPayInstallmentsModal, openPayInstallmentsModal } from '../pay-installments-modal.js';
import { openDeletedScheduleFromActivation } from '../pledge-pay/pledge-pay-deleted-schedule';
import { initViewRecurPaymentModal } from './view-recur-payment-modal.js';
function parseConfig() {
        const el = document.getElementById('member-pledge-page-config');
        if (!el?.textContent) {
            return null;
        }
        try {
            return JSON.parse(el.textContent);
        } catch (e) {
            console.error(e);
            return null;
        }
    }

    function routeWith(routeTemplate, paramName, value) {
        return String(routeTemplate).replace(paramName, encodeURIComponent(String(value)));
    }

function initMemberPledgePage(cfg) {
        const pledgeAddModal = initMemberPledgeAddModal(cfg, {
            onContentRefresh: initMemberPledgePageIfPresent,
        });
        if (document.getElementById('PledgeEditOngoingModal')) {
            initPledgeEditOngoingModal(
                readPledgeEditOngoingModalConfig(),
                createDefaultPledgeEditOngoingModalDeps()
            );
        }
        if (!cfg?.payPledgeMap || typeof cfg.payPledgeMap !== 'object' || Array.isArray(cfg.payPledgeMap)) {
            throw new Error('initMemberPledgePage: payPledgeMap is required');
        }
        initPayPledgeMap(cfg.payPledgeMap);

        async function editRecurring(ongoingDonationId, pledgeType) {
            const $modal = $('#PledgeEditOngoingModal');
            const url = pledgeType === 'Donation'
                ? routeWith(cfg.routes.memberOngoingData, ':id', ongoingDonationId)
                : routeWith(cfg.routes.memberPledgeAjaxData, ':id', ongoingDonationId);
            $modal.addClass('is-ajax-loading').modal('show');
            try {
                const response = await fetch(url, {
                    method: 'GET',
                    headers: { 'X-CSRF-TOKEN': cfg.csrfToken },
                });
                const payload = await response.json();
                if (!payload.success) {
                    $modal.removeClass('is-ajax-loading').modal('hide');
                    showAlertMsg('Error retrieving pledge information', 'danger');
                    return;
                }
                const result = pledgeType === 'Donation' ? payload : payload.data;
                populateOngoingEditModal($modal, result, pledgeType, {
                    ongoingId: ongoingDonationId,
                    amountErrorSelector: '#enter_amt_err',
                });
                $modal.removeClass('is-ajax-loading');
            } catch (err) {
                $modal.removeClass('is-ajax-loading').modal('hide');
                showAlertMsg(AJAX_TIMEOUT_MESSAGE, 'danger');
                openIndexPage();
            }
        }

        function editOngoingModal(ongoingRecordId, pledgeType) {
            editRecurring(ongoingRecordId, pledgeType);
        }

        const { openViewRecurPayments } = initViewRecurPaymentModal({
            routes: cfg.routes,
            csrfToken: cfg.csrfToken,
        });

        function resendReceipt(recordId, tableName, pledgeType, ongoing = false) {
            showOverlay(getMemberOverlayElement());
            $.ajax({
                url: cfg.routes.memberResendReceipt,
                type: 'POST',
                data: {
                    record_id: recordId,
                    table_name: tableName,
                    type: pledgeType,
                    ongoing,
                    _token: cfg.csrfToken,
                },
                success: function (response) {
                    hideOverlay(getMemberOverlayElement());
                    if (!response.success) {
                        showAlertMsg(response.error, 'danger');
                    } else {
                        showAlertMsg('The receipt was successfully re-sent to your email');
                    }
                },
                error: function () {
                    hideOverlay(getMemberOverlayElement());
                    showAlertMsg(AJAX_TIMEOUT_MESSAGE, 'danger');
                    openIndexPage();
                },
            });
        }

        const openMemberPayBillPageFn = getMemberNavAction('openMemberPayBillPage');

        if (document.getElementById('member-pledges-grid')) {
            initializeRowExpander({
                gridId: 'member-pledges-grid',
                delegationRootId: 'member-pledges-grid',
                pledgeExpandContentRoute: cfg.expandContentRoute,
                detailListPartialRoute: '',
                relationshipsPartialRoute: '',
                sourcePage: 'member-pledges',
                portal: 'member',
                paymentUserType: 'user',
                useDivGrid: true,
                defaultMemberId: DEFAULT_MEMBER_ID,
                colspan: 9,
                rowActionHandlers: createPledgesRowActionHandlers({
                    ResendReceipt: resendReceipt,
                    OpenViewRecurPayments: openViewRecurPayments,
                    EditOngoingModal: editOngoingModal,
                    CancelRecurringConfirm: openCancelRecurringConfirm,
                    openMemberPayBillPage: openMemberPayBillPageFn,
                    openPayInstallmentsModal,
                    activateRecurringSchedule: ($btn) => {
                        const url = cfg.routes.activateRecurringSchedule;
                        if (!url) {
                            throw new Error('initMemberPledgePage: activateRecurringSchedule route is required');
                        }
                        showOverlay(getMemberOverlayElement());
                        $.ajax({
                            url,
                            type: 'POST',
                            data: {
                                ongoing_donation_id: $btn.attr('data-pledge-id'),
                                ongoing_type: $btn.attr('data-pledge-type'),
                                _token: cfg.csrfToken,
                            },
                            success(response) {
                                hideOverlay(getMemberOverlayElement());
                                if (!response.success) {
                                    if (openDeletedScheduleFromActivation(response, {
                                        openMemberPayBillPage: openMemberPayBillPageFn,
                                    })) {
                                        showAlertMsg(response.error || 'The gateway schedule was deleted.', 'warning');
                                        return;
                                    }
                                    showAlertMsg(response.error || 'Unable to activate the schedule.', 'danger');
                                    return;
                                }
                                showAlertMsg(response.msg || 'The recurring schedule was activated.');
                                runMemberNavAction('OpenMyPledges');
                            },
                            error() {
                                hideOverlay(getMemberOverlayElement());
                                showAlertMsg(AJAX_TIMEOUT_MESSAGE, 'danger');
                                openIndexPage();
                            },
                        });
                    },
                }),
            });
        }
        initPayInstallmentsModal((res) => {
            showAlertMsg(res.msg || 'Installment payment received.');
            runMemberNavAction('OpenMyPledges');
        });
        initMemberPledgesGrid();

        const memberPledgeActionHandlers = {
            'pay-selected': () => {
                openMemberPayBillPageFn();
            },
            'add-pledge': () => {
                pledgeAddModal.open();
            },
        };

        $(document)
            .off('click.memberPledgeActions', '[data-member-pledge-action]')
            .on('click.memberPledgeActions', '[data-member-pledge-action]', function (event) {
                event.preventDefault();
                const action = $(this).attr('data-member-pledge-action');
                const handler = memberPledgeActionHandlers[action];
                if (handler) {
                    handler($(this));
                }
            });

}

export function initMemberPledgePageIfPresent() {
    const cfg = parseConfig();
    if (!cfg || !document.querySelector('.member-pledges-page')) {
        return;
    }
    initMemberPledgePage(cfg);
}
